import { Checkbox, DatePicker } from 'antd'
import { parseDateOrLeaveEmpty } from '../helpers'
import parse from 'html-react-parser'
import sanitizeHtml from 'sanitize-html'
import { isUrl } from 'Services/WeaverUtils'

AttributesCell = ({ contents = '', dataType }) ->

  switch dataType
    when 'string'
      if _.isObject(contents)
        '{ object }'
      else
        try
          if isUrl(contents)
            <a href={contents} target="_blank">{ contents }</a>
          else
            parse(sanitizeHtml(contents))
        catch
          contents
    when 'double'
      contents
    when 'boolean'
      <Checkbox checked={!!contents} />
    when 'date'
      <DatePicker
        value={parseDateOrLeaveEmpty(contents)}
        size="small"
        allowClear={false}
      />
    else
      try
        parse(sanitizeHtml(contents?.toString() or ''))
      catch
        contents?.toString() or ''


export default AttributesCell
